module.exports = __webpack_public_path__ + "img/jiashuyuyue.2796035a.png";